export const MAX_FILES = 10;
